module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm7.364 17.054L17.216 21.7c-.802.582-1.216.296-1.216-.636V18H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h7v-3.064c0-.932.38-1.216 1.182-.634l6.252 4.644c.8.582.73 1.526-.07 2.108z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-circle-3.js
// module id = 1387
// module chunks = 14